import { Component, model, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';
import { WidgetBaseDetailComponent } from '../../../../shared/components/widget-base-detail/widget-base-detail.component';
import { BaseDetailComponent } from '../../../../common/base-detail.component';
import { DataProtection } from '../../../../generated/generated-types';
import { HotkeysService } from '../../../hotkeys/services/hotkeys.service';
import { AddressDataProtectionLinkService } from '../../services/address-data-protection-link.service';
import { ContactDataProtectionLinkService } from '../../services/contact-data-protection-link.service';
import { DataProtectionService } from '../../services/data-protection.service';
import { dataProtectionFallbackFields } from './fallback-fields';

interface DataProtectionLoadOptions {
  address?: boolean;
  contact?: boolean;
}
@Component({
  selector: 'app-data-protection-widget',
  templateUrl: '../../../../common/base-detail.component.html',
  providers: [HotkeysService],
  imports: [
    WidgetBaseDetailComponent,
  ]
})
export class DataProtectionWidgetComponent extends BaseDetailComponent<DataProtection> {

  addressIdSig = model<string>();
  contactIdSig = model<string>();

  protected route = inject(ActivatedRoute);
  protected router = inject(Router);
  private dataProtectionService = inject(DataProtectionService);
  private addressDataProtectionService = inject(AddressDataProtectionLinkService);
  private contactDataProtectionService = inject(ContactDataProtectionLinkService);
  protected override crudService = this.dataProtectionService;

  constructor() {
    super();
    this.saveButtonIcon = null;
    this.saveButtonLabel = this.baseServices.i18nService.translate(_('data-protection.save-data-protection'));
    this.dataTestId.set('data-protection-widget');
  }

  ngOnInit() {
    // this.listLink = ListLinks.ADDRESSGROUP;
    this.actionBarLocationId = 'data-protection-detail';
    this.fallbackFields = dataProtectionFallbackFields();
    this.autoLoadFormConfig = false;
    super.ngOnInit();
  }

  override ngOnChanges(c: any): void {
    if (c.addressIdSig?.currentValue || c.contactIdSig?.currentValue) {
      this.loadById(c);
    }
    // else
    //   super.ngOnChanges(c);
  }


  override loadById(id: string): void {
    if (this.addressIdSig())
      this.getDataProtection({ address: true });
    else if (this.contactIdSig())
      this.getDataProtection({ contact: true });
    else {
      super.loadById(id);
    }
  }

  async getDataProtection(options: DataProtectionLoadOptions) {
    if (options?.address) {
      if (!this.addressIdSig()) return;
      let addressLink = await this.addressDataProtectionService.getItemDataByAddressId(this.addressIdSig());
      if (addressLink) {
        await this.loadByIdImplementation(addressLink.dataProtectionId);
      }
    }
    else if (options?.contact) {
      if (!this.contactIdSig()) return;
      let contactLink = await this.contactDataProtectionService.getItemDataByContactId(this.contactIdSig());
      if (contactLink) {
        await this.loadByIdImplementation(contactLink.dataProtectionId);
      }
    }
    this.autoLoadFormConfig = true;
    await this.initFieldConfig();

  }

  override async save(model?: Partial<DataProtection>, skipDiffCheck?: boolean): Promise<DataProtection> {

    model = model ?? this.detailModel;
    const savedDataProtection = await super.save(model, skipDiffCheck)

    if (this.addressIdSig()) {
      const addressDataProtectionLink = {
        addressId: this.addressIdSig(),
        dataProtectionId: savedDataProtection.id
      }
      this.addressDataProtectionService.saveItem(addressDataProtectionLink);
    }
    else if (this.contactIdSig()) {
      const contactDataProtectionLink = {
        contactId: this.contactIdSig(),
        dataProtectionId: savedDataProtection.id
      }
      this.contactDataProtectionService.saveItem(contactDataProtectionLink);
    }

    return savedDataProtection;
  }


}
